import { SpeakerPage } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/s/$linkCode'].update({
        staticData: { title: { page: 'Speaker.WaitingRoom.Heading', forWebinar: true } },
        component: SpeakerPage
    });
};
